import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './redux/store'
import { BrowserRouter } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { errorReportingService } from './services/errorReporting.service';

// Initialize global error handlers (window.onerror, unhandledrejection)
errorReportingService.initializeErrorHandlers();

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<ErrorBoundary>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter
					future={{
						v7_startTransition: true,
						v7_relativeSplatPath: true
					}}
				>
					<App />
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</ErrorBoundary>
);
